// db/scalars.ts
import { registerScalar } from "@adornis/baseql/metadata/register.js";
import { Kind } from "graphql";
var BinaryBlob = class {
  constructor() {
    this.isBinaryBlob = true;
  }
  static {
    this._class = "BinaryBlob";
  }
};
registerScalar({
  name: "BinaryBlob",
  customScalarConfig: {
    description: "The `BinaryBlob` scalar type represents binary data, represented as base64 encoded strings.",
    parseValue: (value) => {
      if (typeof value !== "string") {
        throw new Error(`BinaryBlob scalar cannot parse non string (${typeof value}=${value} values`);
      }
      return new Uint8Array(Buffer.from(value, "base64"));
    },
    serialize: (value) => {
      if (value instanceof Uint8Array) {
        return Buffer.from(value).toString("base64");
      }
      if (typeof value === "string") {
        return value;
      }
      throw new Error(`BinaryBlob scalar cannot serialize non Uint8Array (${typeof value}=${value}) values`);
    },
    parseLiteral: (ast) => {
      if (ast.kind === Kind.STRING) {
        return new Uint8Array(Buffer.from(ast.value, "base64"));
      }
      return new Uint8Array([]);
    }
  },
  coerceValue: (value) => {
    if (typeof value === "string") {
      if (globalThis?.Buffer === void 0) {
        return new Uint8Array(
          atob(value).split("").map((c) => c.charCodeAt(0))
        );
      } else {
        return new Uint8Array(Buffer.from(value, "base64"));
      }
    }
    if (!value) {
      return new Uint8Array([]);
    }
    return value;
  },
  type: BinaryBlob,
  toJSPrimitive: (value) => {
    if (value instanceof Uint8Array) {
      return Buffer.from(value).toString("base64");
    }
    return value;
  }
});
export {
  BinaryBlob
};
